
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M29.467 8.612l-7.359-7.358A.86.86 0 0021.497 1H5.144a.865.865 0 00-.865.865v30.27c0 .478.388.865.865.865h23.712a.865.865 0 00.865-.865V9.223c0-.23-.091-.45-.254-.611zm-1.755.69h-6.325V2.978l6.325 6.324zM6.009 31.27V2.73h13.648v7.438c0 .478.387.865.865.865h7.469V31.27H6.009z"}}),_c('path',{attrs:{"d":"M9.75 10.6h6.262a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm0 3.901h14.5a.432.432 0 000-.864H9.75a.432.432 0 000 .864zm2.003 10.244c-.003.418-.119.743-.346.976-.227.232-.526.348-.894.348-.402 0-.71-.108-.922-.324-.213-.217-.318-.52-.318-.906H8.38c0 .619.187 1.101.561 1.445.375.343.899.515 1.571.515.647 0 1.165-.182 1.554-.548.388-.366.583-.872.583-1.52v-4.789h-.897v4.803zm4.91-4.803h-2.494v6.763h.892v-2.647h1.593c.765 0 1.353-.177 1.763-.532.41-.355.615-.861.615-1.516 0-.624-.209-1.123-.629-1.501-.421-.378-1-.567-1.74-.567zm1.096 3.048c-.254.225-.62.338-1.097.338H15.06v-2.657h1.654c.443.008.791.134 1.046.376.253.242.381.565.381.968-.001.426-.128.751-.382.975zm3.556-1.782c.308-.419.761-.63 1.359-.63.899 0 1.43.449 1.598 1.347h.892c-.096-.662-.36-1.174-.79-1.534-.431-.361-.999-.541-1.705-.541-.861 0-1.529.28-2.005.841-.475.56-.713 1.35-.713 2.369v.59c.006.629.126 1.181.36 1.658.234.477.564.846.992 1.104.427.258.917.387 1.468.387.545 0 1.023-.081 1.433-.244.41-.163.73-.408.959-.736v-2.481H22.71v.73h1.565v1.515a1.357 1.357 0 01-.623.375 3.113 3.113 0 01-.878.111c-.592 0-1.06-.224-1.407-.671-.347-.448-.521-1.052-.521-1.811v-.554c.005-.797.161-1.405.469-1.825z"}})])])
          )
        }
      }
    